import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asus_proart_sw_ico_arrow_s3",
  "use": "asus_proart_sw_ico_arrow_s3-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"asus_proart_sw_ico_arrow_s3\">\n<g id=\"asus_proart_sw_ico_arrow_s3_asus_proart_sw_ico_first\">\n\t<g id=\"asus_proart_sw_ico_arrow_s3_asus_proart_sw_ico_first-2\">\n\t\t<path d=\"M18.8,32.2L27,24l-8.1-8.2l1.4-1.4l8.9,8.9c0,0,0,0,0,0c0.4,0.4,0.4,1,0,1.4l-8.9,8.9L18.8,32.2z\" />\n\t\t<rect x=\"0\" fill=\"none\" width=\"48\" height=\"48\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol